// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MentionsLegales_wrapper__rL90z"};